export enum CheckboxType {
  circle = 'circle',
  rect = 'rect'
}
